import { useLocation } from 'react-router-dom';

import { observer } from 'mobx-react-lite';
import qs from 'qs';

import { Button } from '@components/button';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Tag } from '@components/tag';
import { Text } from '@components/text';
import { useToaster } from '@components/toaster';

import { Loading } from 'components/Loading';
import { useModel } from 'hooks/useModel';
import { useStore } from 'models/Provider';

import { HRMonitorSettings } from './Models';

export const HRMonitorSettingsPage = observer(() => {
  const { t, api } = useStore();
  const { showError, showSuccess } = useToaster();
  const location = useLocation();
  const model = useModel(HRMonitorSettings, {}, { api, showError, showSuccess, t });
  const parsed = qs.parse(location.search, { ignoreQueryPrefix: true });
  const companyId = parsed['company-id'];
  if (companyId && !model.hasCompanyId && !model.loading) {
    model.setCompanyId(companyId);
  }

  if (!model.redirectUrl && !model.hasCompanyId) {
    return <Loading />;
  }

  return (
    <Stack space={6}>
      <Stack space={2}>
        <Text font="heading2">{t('integrations.hrmonitor.settings.header')}</Text>
        <div>
          {model.hasCompanyId && (
            <Tag
              size="small"
              variant="green"
              text={t('integrations.hrmonitor.settings.header.connected')}
            />
          )}
          {!model.hasCompanyId && (
            <Tag
              size="small"
              variant="purple"
              text={t('integrations.hrmonitor.settings.header.notconnected')}
            />
          )}
        </div>
      </Stack>
      <Separator />
      <Text text={t('integrations.hrmonitor.settings.info')} />
      {!model.hasCompanyId && model.redirectUrl !== '' && (
        <Stack orientation="horizontal" justify="flex-end">
          <Button
            as="a"
            href={model.redirectUrl}
            text={t('integrations.hrmonitor.settings.connect')}
          />
        </Stack>
      )}
    </Stack>
  );
});
